import { Button, FormControl, Grid, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DOAIconComp } from "../../components/DOAIconComp";
import { DatePickerComp, DatePickerCompProps } from "../../components/DatePickerComp";
import { MainContainer } from "../../components/MainContainerComp";
import { Shift, Shifts } from "./GangWayReportModels";
import { GridItemStyle, asteriskStyle, buttonContainerStyle, descriptionStyle, selectStyle } from "./styled";

interface IGangWayReportProps {
  datePickerCompProps: DatePickerCompProps;
  dispatchType: string;
  disabledView: boolean;
  handleSubmit: () => void;
  handleShiftChange: (event: SelectChangeEvent<string>) => void;
}

export const GangWayReport: React.FC<IGangWayReportProps> = ({
  datePickerCompProps,
  dispatchType,
  disabledView,
  handleSubmit,
  handleShiftChange,
}) => {
  const decodeString = (shift: Shift) => {
    switch (shift) {
      case Shift.DAY:
        return "DAY";
      case Shift.NIGHT:
        return "NIGHT";
      case Shift.GRAVEYARD:
        return "GRAVEYARD";
      case Shift.COASTWISE:
        return "COASTWISE";
      case Shift.SQUAMISH:
        return "SQUAMISH";
      default:
        return shift;
    }
  };

  return (
    <MainContainer hasGreyBg>
      <DOAIconComp />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Typography sx={descriptionStyle} data-automation="description-text">
          The Gangway Report will display Availability of Gangway list for a given date and dispatch.
        </Typography>
        <DatePickerComp {...datePickerCompProps} />
        <Grid sx={{ justifyContent: 'center' }} container>
          <Grid item xs={12} md={4} sx={GridItemStyle}>
            <Typography>Dispatch Shift <Typography component={"span"} sx={asteriskStyle}>*</Typography></Typography>
            <FormControl fullWidth>
              <Select
                sx={selectStyle}
                fullWidth
                value={dispatchType}
                onChange={handleShiftChange}
                data-automation="dispatch-shift"
              >
                {Shifts.map((shift) => (
                  <MenuItem
                    key={shift}
                    value={shift}
                    data-automation="dropdown-dispatch-shift"
                  >
                    {shift === "67" || shift === "68" ?
                      "5:45 - " + decodeString(shift) :
                      decodeString(shift)
                    }
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid sx={{ justifyContent: 'center' }} container>
          <Grid sx={buttonContainerStyle} item xs={12} md={8}>
            <Button
              onClick={handleSubmit}
              disabled={disabledView}
              variant="contained"
              size="medium"
              data-automation="view-btn"
            >
              View Report
            </Button>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </MainContainer>
  )
}